import React from 'react';
import './PlanProposeContent.css';
import {useTranslation} from "react-i18next";

interface ProgressPoint {
    month: string;
    level: string;
    isHighlighted?: boolean;
}

export interface PlanProposeContentProps {
    title: string;
    subtitle: string;
    targetDate: string;
    step: any;
    goal: {
        emoji: string;
        text: string;
    };
    progressPoints: ProgressPoint[];
}

export const PlanProposeContent: React.FC<PlanProposeContentProps> = ({
    title,
    subtitle,
    targetDate,
    goal,
    progressPoints
}) => {
    const { t} = useTranslation()
    return (
        <div className="plan-propose">
            <div className="plan-propose__header">
                <h1 className="plan-propose__title">{title}</h1>
                <p className="plan-propose__subtitle">
                    Based on your answers, we expect you to gain necessary skills of{' '}
                    <span className="plan-propose__highlight">AI Master by {targetDate}</span>
                </p>
            </div>

            <div className="plan-propose__goal">
                <span>{t('yourGoal')}: {goal.emoji} {goal.text}</span>
            </div>

            <div className="plan-propose__chart">
                <div className="plan-propose__chart-bars">
                    {progressPoints.map((point, index) => (
                        <div
                            key={index}
                            className={`plan-propose__chart-bar ${
                                point.isHighlighted ? 'plan-propose__chart-bar--highlighted' : ''
                            }`}
                        >
                            {point.isHighlighted && (
                                <div className="plan-propose__chart-label">
                                    {point.level}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div className="plan-propose__chart-months">
                    {progressPoints.map((point, index) => (
                        <div key={index} className="plan-propose__chart-month">
                            {point.month}
                        </div>
                    ))}
                </div>
            </div>

            <button className="plan-propose__continue">
                {t('continueButtonText')}
            </button>
        </div>
    );
};
